module.exports = __webpack_public_path__ + "img/gather_skirt.2b106e68.png";